<template>

	<div class="p--login container-fluid bg-white p-0">
		<div
			class="row row-login align-items-center justify-content-center m-0"
			:style="{
				backgroundImage: 'url(' + $store.state.settings.background + ')',
				backgroundSize: 'cover',
				backgroundPosition: 'center'
			}"
		>

			<div class="col-12 col-md-6 col-lg-4">

				<div class="card">
					<div class="card-body">
						<div class="p-15">
							<a :href="$store.state.settings.path">
								<div class="m-b-30 text-center">
									<img
										class="img-fluid inline-block"
										style="max-height: 60px"
										:src="$store.state.settings.logotipo"
										alt="App logo"
									/>
									<!-- <h2 class="inline-block pull-right m-0 align-middle pl-3 text-uppercase">{{ $store.state.settings.name }}</h2> -->
									<hr />
								</div>
							</a>
							<router-view />
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
	
</template>

<style>
.row-login {
	min-height: 100vh;
}

.col-sl {
	max-width: 500px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;

	@media only screen and (max-width: 1024px) {
		max-width: 100%;
	}
}

.card {
	border-radius: 20px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
	border: none;
}

.card-body {
	padding: 40px 30px;
}

.col-sr {
	min-height: 100vh;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
</style>

<script>
export default {
	name: "Auth",
	metaInfo() {
		return {
			title: this.$i18n.t("Authentication"),
		};
	},
	data() {
		return { isRegister: false };
	},
	mounted() {
		this.$route.name == "register"
		? (this.isRegister = true)
		: (this.isRegister = false);
	},
};
</script>